import React, { useContext } from 'react';
import { Approval } from 'api/approval';

interface Result {
  newApprovalData: Partial<Approval> | undefined;
  setNewApprovalData: (data: Partial<Approval> | undefined) => void;
}
export const ApprovalsPaneContext = React.createContext<Result | null>(null);

export const useApprovalsPaneContext = (): Result => {
  const context = useContext(ApprovalsPaneContext);

  if (!context) {
    throw new Error(
      'This must be used within a <TaskPane> component or wrap it with ApprovalsPaneContext.Provider.',
    );
  }

  return context;
};
